import * as React from "react";
import { useState, useEffect } from "react";
import styled from "styled-components";
import { Alert, Button } from "components/bootstrap";
import { DEFAULT_PAGE_SIZES } from "hooks/usePaginationQueryParameter";
import CollectionGranteesListItem from "collections/components/CollectionGranteeListItem";
import {
  StyledGranteeList,
  GranteeListHeader,
  GranteeListPaginationWrapper,
  GranteeListStyledPagination,
  GranteeListStyledPageSizeSelect
} from "components/permissions/CommonStyledComponents";
import useCollectionGrantees from "collections/hooks/useCollectionGrantees";
import { Icon } from "components/common";
const StyledDiv = styled.div`
  padding: 0;
  margin-bottom: ${(props) => props.theme.spacings.sm};
`;
const ToggleButton = styled(Button)`
  padding: 0;
  margin-bottom: ${(props) => props.theme.spacings.sm};
`;
const ToggleIcon = styled(Icon)`
  margin-left: ${(props) => props.theme.spacings.sm};
`;
const _paginatedGrantees = (selectedCollectionGrantees, pageSize, currentPage) => {
  const begin = pageSize * (currentPage - 1);
  const end = begin + pageSize;
  return selectedCollectionGrantees.slice(begin, end);
};
const CollectionGranteesList = ({ entityType, entityTypeTitle = null, title, entityGRN }) => {
  const { data } = useCollectionGrantees(entityGRN);
  const collectionGrantees = data.list.map((dataGrantee) => ({
    granteeName: dataGrantee.granteeName,
    grantee: dataGrantee.grantee,
    collection_id: dataGrantee.collection_id,
    collection_name: dataGrantee.collection_name,
    collection_total: dataGrantee.collection_total,
    capability: dataGrantee.capability
  }));
  const initialPageSize = DEFAULT_PAGE_SIZES[0];
  const [pageSize, setPageSize] = useState(initialPageSize);
  const [currentPage, setCurrentPage] = useState(1);
  const paginatedGrantees = _paginatedGrantees(collectionGrantees, pageSize, currentPage);
  const hasGrantees = collectionGrantees.length > 0;
  const [showGranteeList, setShowGranteeList] = useState(false);
  const totalGrantees = collectionGrantees.length;
  const totalPages = Math.ceil(totalGrantees / pageSize);
  const showPageSizeSelect = totalGrantees > initialPageSize;
  const handlePageSizeChange = (newSize) => {
    setPageSize(newSize);
    const newTotalPages = Math.ceil(totalPages / newSize);
    if (currentPage > newTotalPages) setCurrentPage(newTotalPages);
  };
  useEffect(() => {
    if (hasGrantees) {
      setShowGranteeList(true);
    }
  }, [hasGrantees]);
  return /* @__PURE__ */ React.createElement(StyledDiv, null, /* @__PURE__ */ React.createElement(GranteeListHeader, null, /* @__PURE__ */ React.createElement(
    ToggleButton,
    {
      bsStyle: "link",
      onClick: () => {
        setShowGranteeList((cur) => !cur);
      }
    },
    title,
    showPageSizeSelect && /* @__PURE__ */ React.createElement(
      GranteeListStyledPageSizeSelect,
      {
        onChange: (newPageSize) => handlePageSizeChange(newPageSize),
        pageSize
      }
    ),
    /* @__PURE__ */ React.createElement(ToggleIcon, { name: showGranteeList ? "keyboard_arrow_up" : "keyboard_arrow_down" })
  )), showGranteeList && /* @__PURE__ */ React.createElement(React.Fragment, null, hasGrantees ? /* @__PURE__ */ React.createElement(StyledGranteeList, null, paginatedGrantees.map((collectionGrantee) => /* @__PURE__ */ React.createElement(
    CollectionGranteesListItem,
    {
      key: `${collectionGrantee.collection_id}-${collectionGrantee.granteeName}`,
      grantee: collectionGrantee
    }
  ))) : /* @__PURE__ */ React.createElement(Alert, null, "This ", entityTypeTitle || entityType, " has no collection collaborators."), /* @__PURE__ */ React.createElement(GranteeListPaginationWrapper, null, /* @__PURE__ */ React.createElement(GranteeListStyledPagination, { totalPages, currentPage, onChange: setCurrentPage }))));
};
export default CollectionGranteesList;
